import { RequestMainService } from '../request'

export class CommissionService {
  static async getHistoryDirectCommission(params: any = {}) {
    return RequestMainService.get(`/admin/direct-referral-tracking`, params).then(({ result }) => ({
      count: result.total,
      data: result.data,
      totalDirectReferralInvestProfit: result?.totalDirectReferralInvestProfit,
    }))
  }

  static async getHistorySunlineAndSameRankCommission(params: any = {}) {
    return RequestMainService.get(`/admin/sun-line-tracking`, params).then(({ result }) => ({
      count: result.total,
      data: result.data,
      totalSunLineCommissionAmount: result?.totalSunLineCommissionAmount,
      totalSameRankCommissionAmount: result?.totalSameRankCommissionAmount,
    }))
  }

  static async getRankTracking(params: any = {}) {
    return RequestMainService.get(`/admin/user-rank-tracking`, params).then(({ result }) => ({
      count: result.total,
      data: result.data,
    }))
  }

  static async getHistoryUpdateRank(params: any = {}) {
    return RequestMainService.get(`/admin/affiliation-rank`, params).then(({ result }) => ({
      count: result.total,
      data: result.data,
    }))
  }

  static async updateRank(payload: any) {
    return RequestMainService.put(`/admin/update-rank`, payload)
  }
}
